import { Delete } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import Grid2 from "@mui/material/Grid2";
import React from "react";
import { useFormContext } from "react-hook-form";
import FormTextField from "../../Common/FormTextField";
import { getFieldPath } from "../../Common/SchemaUtils";

const AddressFormFields: React.FC<{
  extractionId: string;
  extractionPath?: string;
  label?: string;
  remove?: Function;
}> = ({ extractionId, extractionPath, remove }) => {
  const { control } = useFormContext();
  return (
    <Grid2
      container
      spacing={2}
      key={getFieldPath([extractionId, extractionPath])}
      sx={{ alignItems: "center" }}
    >
      <Grid2 size={4}>
        <FormTextField
          size="small"
          name={`extraction.${getFieldPath([extractionId, "value", extractionPath])}.number`}
          control={control}
          label="Numéro"
        />
      </Grid2>
      <Grid2 size={8}>
        <FormTextField
          size="small"
          name={`extraction.${getFieldPath([extractionId, "value", extractionPath])}.way`}
          control={control}
          label="Rue"
        />
      </Grid2>
      <Grid2 size={6}>
        <FormTextField
          size="small"
          name={`extraction.${getFieldPath([extractionId, "value", extractionPath])}.postal_code`}
          control={control}
          label="Code postal"
        />
      </Grid2>
      <Grid2 size={6}>
        <FormTextField
          size="small"
          name={`extraction.${getFieldPath([extractionId, "value", extractionPath])}.city`}
          control={control}
          label="Ville"
        />
      </Grid2>
      <Grid2 size={remove !== undefined ? 10 : 12}>
        <FormTextField
          size="small"
          name={`extraction.${getFieldPath([extractionId, "value", extractionPath])}.country`}
          control={control}
          label="Pays"
          className="grow"
        />
      </Grid2>
      {remove !== undefined && (
        <Grid2 size={2} sx={{ textAlign: "right", pt: 0.5 }}>
          <IconButton
            onClick={() => {
              remove();
            }}
            className="rounded-full"
            size="small"
          >
            <Delete color="error" />
          </IconButton>
        </Grid2>
      )}
    </Grid2>
  );
};

export default AddressFormFields;
